import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import DOMPurify from "isomorphic-dompurify";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const sanitizeHTML = (content: string) => {
  let html = DOMPurify.sanitize(content, {
    ADD_ATTR: ['target'],
    ADD_TAGS: ['iframe']
  });
  // Strip role and dir attributes from <li> elements — TipTap/Directus editor
  // outputs role="presentation" dir="ltr" which are invalid in W3C for li inside ul/ol
  html = html.replace(/<li\b([^>]*)>/gi, (_match, attrs: string) => {
    const cleaned = attrs
      .replace(/\s+role="[^"]*"/gi, '')
      .replace(/\s+dir="[^"]*"/gi, '');
    return `<li${cleaned}>`;
  });
  return { __html: html };
};

export const shimmer = (w: number, h: number) => `
  <svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient id="g">
        <stop stop-color="#333" offset="20%" />
        <stop stop-color="#222" offset="50%" />
        <stop stop-color="#333" offset="70%" />
      </linearGradient>
    </defs>
    <rect width="${w}" height="${h}" fill="#333" />
    <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  </svg>`

export const toBase64 = (str: string) =>
  typeof window === 'undefined'
    ? Buffer.from(str).toString('base64')
    : window.btoa(str)
